import { useTheme } from '@mui/material';
import type { Icon } from 'iconsax-react';
import {
  Document,
  DocumentText,
  DocumentText1,
  Image as ImageIcon,
  TableDocument,
  Text as TextIcon,
} from 'iconsax-react';
import type { FC } from 'react';

import type { AllowedAttachmentExtension } from '@core/constants/app';
import { getFileExtension } from '@core/utils/fileAttachments';

const DEFAULT_FILE_ICON_SIZE = 20;

/** extension -> icon. Shared with SC-5475's file list. */
const EXTENSION_ICONS: Record<AllowedAttachmentExtension, Icon> = {
  '.pdf': DocumentText,
  '.doc': Document,
  '.docx': Document,
  '.xls': TableDocument,
  '.xlsx': TableDocument,
  '.jpg': ImageIcon,
  '.jpeg': ImageIcon,
  '.png': ImageIcon,
  '.txt': TextIcon,
};

const isKnownFileIconExtension = (extension: string): extension is AllowedAttachmentExtension =>
  extension in EXTENSION_ICONS;

type Props = {
  fileName: string;
  size?: number;
};

export const FileTypeIcon: FC<Props> = ({ fileName, size = DEFAULT_FILE_ICON_SIZE }) => {
  const theme = useTheme();
  const extension = getFileExtension(fileName);
  const IconComponent = isKnownFileIconExtension(extension)
    ? EXTENSION_ICONS[extension]
    : DocumentText1;

  return <IconComponent variant='TwoTone' color={theme.palette.SlabIndigo[700]} size={size} />;
};
